/**
 * Route for `gclid-only-attribution`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GclidOnlyAttributionPage } from "../features/gclid-only-attribution/GclidOnlyAttributionPage";

export const gclidOnlyAttributionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/gclid-only-attribution",
	component: GclidOnlyAttributionPage,
});

export default gclidOnlyAttributionRoute;
